import React, {
    useEffect, useState, FC,
} from 'react';
import {useDispatch} from 'react-redux';

import {
    IListEntityMeta, loadMetadata, resetMetadata, selectMetadata,
} from 'entities/metadata';
import {selectEntityData} from 'modules/data';
import {
    filterNonRenderableFieldsAndUpdateState,
    loadFormPageData,
} from 'modules/data/data-actions';
import {IListEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';
import {selectUserInfo} from 'store/slices/auth-slice';

import {Spinner} from '../spinner';
import {List} from './List';

interface IListComponentProps {
    entityName: string;
}

export const ListContainer: FC<IListComponentProps> = ({
    entityName,
}: IListComponentProps) => {
    const dispatch = useDispatch();

    const userInfo = useAppSelector(selectUserInfo);
    const metadata = useAppSelector(selectMetadata(entityName, EEntityType.LIST)) as IListEntityMeta;
    const listData = useAppSelector(selectEntityData(entityName, EEntityType.FORM)) as IListEntityData;

    const [isLoading, setIsLoading] = useState(false);
    const [fieldsFiltered, setFieldsFiltered] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            if (!metadata) {
                setIsLoading(true);
                await dispatch(loadMetadata(entityName, EEntityType.LIST));
                setIsLoading(false);
            }

            if (!listData) {
                setIsLoading(true);
                await dispatch(loadFormPageData(entityName, entityName));
                setIsLoading(false);
            }
        })();
        return () => {
            dispatch(resetMetadata({
                entityType: EEntityType.LIST,
                loading: false,
                entityName: entityName || '',
            }));
        };
    }, []);

    useEffect(() => {
        if (metadata?.fields && !fieldsFiltered) {
            dispatch(
                filterNonRenderableFieldsAndUpdateState(
                    metadata,
                    metadata.name,
                    EEntityType.LIST,
                    setFieldsFiltered,
                ),
            );
        }
    }, [metadata?.fields, userInfo]);

    return (
        isLoading
            ? <div className="list-modal__spinner"><Spinner /></div>
            : (
                <List
                    listData={listData}
                    meta={metadata}
                />
            )
    );
};
